module.exports = __webpack_public_path__ + "static/media/Banner.c59de742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assents/Banner.png
// module id = 293
// module chunks = 0